import React from "react";
import { Link } from "react-router-dom";
import FadeIn from "../FadeIn";
import Button from "../Button";
import Card from "../Card";
import CardContent from "../CardContent";
import heroImage from "../../assets/lawncarelandscaping.webp";
import ServiceArea from "./ServiceArea";
import Testimonials from "./Testimonials";
import TrustIcons from "./TrustIcons";
import ReactGA from "react-ga4";
import { serviceData } from "./ServiceData";

const Home = ({ onOpenEstimate }) => (
  <main className="max-w-7xl mx-auto">
    {/* Lazy Preload Hero Image */}
    <img
      src={heroImage}
      alt="LawnSmartPro lawn care"
      loading="lazy"
      style={{ display: "none" }}
    />

    {/* Hero Section */}
    <section
      className="relative h-[70vh] bg-cover bg-center flex items-center justify-center text-center px-4"
      style={{
        backgroundImage: `url(${heroImage})`,
        backgroundAttachment: "scroll",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
    >
      <div className="absolute inset-0 bg-black bg-opacity-50"></div>
      <FadeIn className="relative z-10">
        <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4 leading-tight">
          LawnSmartPro: Your Lawn's Secret Weapon 🌿
        </h1>
        <p className="text-gray-100 max-w-xl mx-auto text-lg">
          Hassle-free lawn care and landscaping in New Jersey. Book an estimate
          online in under 60 seconds.
        </p>
        <div className="mt-6">
          <Button
            onClick={() => {
              ReactGA.event({
                category: "Estimate",
                action: "Clicked Get Your Free Estimate",
                label: "Homepage Hero Button",
              });
              onOpenEstimate(); // ← keep your existing action
            }}
          >
            Get Your Free Estimate
          </Button>{" "}
        </div>
      </FadeIn>
    </section>

    {/* Services Section */}
    <section className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 p-6">
      {Object.entries(serviceData).map(([slug, data]) => (
        <FadeIn key={slug}>
          <Card>
            <CardContent>
              <div className="flex items-center gap-4 mb-4">
                {data.icon}
                <h3 className="text-xl font-bold text-gray-800">
                  {data.title}
                </h3>
              </div>
              <ul className="list-disc pl-6 space-y-1 text-gray-600 text-sm">
                {data.points.slice(0, 3).map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
              <div className="mt-4">
                <Link
                  to={`/services/${slug}`}
                  className="text-green-600 font-medium hover:underline"
                >
                  Learn more →
                </Link>
              </div>
            </CardContent>
          </Card>
        </FadeIn>
      ))}
    </section>

    {/* Trust Section */}
    <section className="mt-16 text-center px-6">
      <FadeIn>
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">
          Why Homeowners Choose LawnSmartPro
        </h2>
        <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 text-sm text-gray-700">
          <li className="bg-green-50 p-4 rounded-xl shadow-sm">
            Locally Owned & Operated
          </li>
          <li className="bg-green-50 p-4 rounded-xl shadow-sm">
            Flexible Service Plans
          </li>
          <li className="bg-green-50 p-4 rounded-xl shadow-sm">
            Smart Irrigation Experts
          </li>
          <li className="bg-green-50 p-4 rounded-xl shadow-sm">
            Top-Rated by Homeowners
          </li>
        </ul>
      </FadeIn>
    </section>

    <ServiceArea />
    <Testimonials />
    <TrustIcons />
  </main>
);

export default Home;
